class GlobalEventHandler {
  constructor() {
    document.addEventListener('click', this.superClass_HandleClick.bind(this));
    document.addEventListener('change', this.superClass_HandleChange.bind(this));
    document.addEventListener('DOMContentLoaded', this.superClass_HandleDOMContentLoaded.bind(this));
    window.addEventListener('load', this.superClass_HandleLoad.bind(this));
    this.superHandle_ImmediateFire();
  }

  superClass_HandleClick(event) { this.overrideHandle_ClickTemplate(event); }
  superClass_HandleChange(event) { this.overrideHandle_ChangeTemplate(event); }
  superClass_HandleLoad(event) { this.overrideHandle_LoadTemplate(event); }
  superClass_HandleDOMContentLoaded(event) { this.overrideHandle_DOMContentLoadedTemplate(event); }

  overrideHandle_ClickTemplate(event) { return event; }
  overrideHandle_ChangeTemplate(event) { return event; }
  overrideHandle_LoadTemplate(event) { return event; }
  overrideHandle_DOMContentLoadedTemplate(event) { return event; }
  superHandle_ImmediateFire() {}

}


